import { Vocabulary } from "../../../Utils/Vocabulary";
import EditDeleteButtons from "../../GenericComponents/EditDeleteButtons";
import { OrderContext } from "../../../Contexts/OrderContext";
import { useContext } from "react";
import { useMediaQuery } from "@mui/material";
import ImageGallery from "../../GenericComponents/ImageGallery";

type OrderCustomerProps = {
  onEdit: () => void;
};

export default function OrderCustomer(props: OrderCustomerProps) {
  const { onEdit } = props;
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const orderContext = useContext(OrderContext);
  return (
    <div style={{ position: "relative" }}>
      {orderContext.order.orderedBy ? (
        <div>
          <p>
            <span style={{ fontWeight: "bold" }}>
              {Vocabulary.customerName}:
            </span>
            &nbsp;&nbsp;
            {phoneStyle ? <br /> : null}
            {orderContext.order.orderedBy.name}
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>{Vocabulary.phone}:</span>
            &nbsp;&nbsp;
            {orderContext.order.orderedBy.phone}
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>{Vocabulary.email}:</span>
            &nbsp;&nbsp;
            {orderContext.order.orderedBy.email}
          </p>
          {orderContext.order.orderedBy.address && (
            <p>
              <span style={{ fontWeight: "bold" }}>
                {Vocabulary.customerAddress}:
              </span>
              &nbsp;&nbsp;
              {orderContext.order.orderedBy.address.details},{" "}
              {orderContext.order.orderedBy.address.postcode}
              {", "}
              {orderContext.order.orderedBy.address.country}
              {", "}
              {orderContext.order.orderedBy.address.county}
              {", "}
              {orderContext.order.orderedBy.address.city}
            </p>
          )}
          <p>
            <span style={{ fontWeight: "bold" }}>
              {Vocabulary.clientMessage}:
            </span>
            &nbsp;&nbsp;
            {orderContext.order?.orderedBy?.observations?.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
          {orderContext?.order?.documents && orderContext.order.documents.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <p style={{ fontWeight: "bold", marginBottom: 8 }}>
                {Vocabulary.attachedDocuments}:
              </p>
              <ImageGallery
                images={orderContext.order.documents}
                maxHeight={120}
                columns={4}
              />
            </div>
          )}
          <EditDeleteButtons
            onEdit={onEdit}
            onDelete={() =>
              orderContext.setOrder({
                ...orderContext.order,
                orderedBy: null,
              })
            }
            style={{ position: "absolute", top: 0, right: 0 }}
          />
        </div>
      ) : null}
    </div>
  );
}
